import request from '@/utils/request'

export function login(username, password) {
    return request({
        url: '/auth/signIn',
        method: 'post',
        data: {
            username,
            password
        }
    })
}

export function verifyAccess(data) {
    return request({
        url: '/auth/verifyAccess',
        method: 'post',
        data: data,
    })
}

export function checkDomain(params) {
    return request({
        url: '/auth/checkDomain',
        method: 'get',
        params: params,
    })
}

export function getInfo() {
    return request({
        url: '/auth/userInfo',
        method: 'get',
    })
}

export function logout() {
    return request({
        url: '/auth/logout',
        method: 'post'
    })
}

export function signup(username, password, name) {
    return request({
        url: '/auth/signUp',
        method: 'post',
        data: {
            username,
            password,
            name
        }
    })
}
